import React, { useState, useEffect } from "react";
import { Button } from "./Button";
import { Link } from "react-scroll";
import { AiOutlineDingding } from "react-icons/ai";
import { ImCross } from "react-icons/im";
import "./Navbar.css";

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener("resize", showButton);

  return (
    <>
      <nav className="navbar fixed-top">
        <div className="navbar-container">
          <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
            JAY <AiOutlineDingding />
          </Link>
          <div className="menu-icon" onClick={handleClick}>
            <i className={click ? <ImCross /> : "fas fa-bars"} />
          </div>
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <Link
                to="about"
                className="nav-links"
                onClick={closeMobileMenu}
                activeClass="active"
                spy={true}
                smooth={true}
                duration={1000}
              >
                About Me
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="services"
                className="nav-links"
                onClick={closeMobileMenu}
                activeClass="active"
                spy={true}
                smooth={true}
                duration={1000}
              >
                Services
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="education"
                className="nav-links"
                onClick={closeMobileMenu}
                activeClass="active"
                spy={true}
                smooth={true}
                duration={1000}
              >
                Education
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="work"
                className="nav-links"
                onClick={closeMobileMenu}
                activeClass="active"
                spy={true}
                smooth={true}
                duration={1000}
              >
                My Work
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="contact"
                className="nav-links"
                onClick={closeMobileMenu}
                activeClass="active"
                spy={true}
                smooth={true}
                duration={1000}
              >
                Contact Me
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
